var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-item", on: { click: _vm.handleClick } },
    [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "card-title-group" }, [
          _c("i", {
            class: _vm.card.completed
              ? "el-icon-success checked"
              : "el-icon-circle-check",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$emit("toggle-check", _vm.card)
              },
            },
          }),
          _c("span", { class: { "text-completed": _vm.card.completed } }, [
            _vm._v(_vm._s(_vm.card.title)),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "card-actions",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("el-button", {
              attrs: {
                size: "mini",
                icon: "el-icon-delete action-icon",
                circle: "",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("archive", _vm.card)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "card-footer" }, [
        _vm.card.dueDateTime
          ? _c(
              "span",
              {
                staticClass: "badge date-badge",
                class: { "is-completed": _vm.card.completed },
              },
              [
                _c("i", { staticClass: "el-icon-time" }),
                _vm._v(
                  " " + _vm._s(_vm.formatDate(_vm.card.dueDateTime)) + " "
                ),
              ]
            )
          : _vm._e(),
        _vm.card.activities && _vm.card.activities.length > 0
          ? _c("span", { staticClass: "badge-icon" }, [
              _c("i", { staticClass: "el-icon-chat-square" }),
              _vm._v(" " + _vm._s(_vm.card.activities.length) + " "),
            ])
          : _vm._e(),
        _vm.card.attachments && _vm.card.attachments.length > 0
          ? _c("span", { staticClass: "badge-icon" }, [
              _c("i", { staticClass: "el-icon-paperclip" }),
              _vm._v(" " + _vm._s(_vm.card.attachments.length) + " "),
            ])
          : _vm._e(),
        _vm.card.members && _vm.card.members.length > 0
          ? _c(
              "span",
              { staticClass: "badge-icon" },
              [
                _c(
                  "el-avatar",
                  {
                    attrs: {
                      size: "small",
                      src: _vm.getMember(_vm.card.members[0].id).avatar,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getMember(_vm.card.members[0].id).name.charAt(0)
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }